export const CURRENT_LANGUAGE_STORAGE_KEY = 'Translate:CurrentLanguage';
